import { render, staticRenderFns } from "./AssignProductsStock.vue?vue&type=template&id=74d91a33"
import script from "./AssignProductsStock.vue?vue&type=script&lang=js"
export * from "./AssignProductsStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports